<form class="form-horizontal" autocomplete="off" #reasonForm="ngForm" (ngSubmit)="save()">
    <abp-modal-header [title]="'lbl_common_enterReason' | localize" (onCloseClick)="bsModalRef.hide()"></abp-modal-header>
    <div class="modal-body row">
        <div class="col-md-12">
            <textarea
                type="text"
                class="form-control"
                style="height: 200px"
                id="reason"
                name="reason"
                [(ngModel)]="reason"
                [(ngModel)]="reason"
                required
                #reasonModel="ngModel"
                #reasonEl
            ></textarea>
            <abp-validation-summary [control]="reasonModel" [controlEl]="reasonEl"></abp-validation-summary>
        </div>
    </div>
    <div class="topbar-right">
        <div class="topbar-right" style="display: flex; margin-bottom: 20px; padding-top: 0px">
            <button type="submit" class="btn bg-success bt-approve" style="margin-right: 5px" [disabled]="!reasonForm.form.valid || saving">
                <i class="fa fa-save"></i>
                {{ 'btn_save' | localize }}
            </button>
            <button type="button" class="btn bg-danger bt-reject" (click)="bsModalRef.hide()">
                <i class="fas fa-sign-out-alt"></i>
                {{ 'btn_cancle2' | localize }}
            </button>
        </div>
    </div>
</form>
